/** Styl komponenty ProgressSpinner k tématu Erma */
export const ProgressSpinnerStyles = {
  color: {//pouze zelená je z globálního stylu. Ostatní bervy převzaty z verze 13.
    1: 'var(--erma-primary-500)',
    2: '#0057e7',
    3: '#ffa700',
    4: '#d62d20',
  }
};
